import Factory from '../factory';

const schema = Factory.schema('news-and-views');

export default schema;
